import React from 'react'
import { Grid, Heading } from '@chakra-ui/react'
import { StockData } from '../types'
import StatCard from './StatCard'
import { formatCurrency, formatNumber } from '../utils'

interface KeyStatsPanelProps {
  data: StockData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const KeyStatsPanel: React.FC<KeyStatsPanelProps> = ({
  data,
  gridTemplateColumns,
  statCardBg
}) => (
  <>
    <Heading as="h3" fontSize="xl" mb={4}>
      Key Statistics
    </Heading>
    
    <Grid
      gap={4}
      templateColumns={`repeat(${gridTemplateColumns || 1}, 1fr)`}
      width="100%"
    >
      <StatCard
        bg={statCardBg}
        label="EPS"
        value={`$${data.keyStats.eps.toFixed(2)}`}
        helpText="Earnings per share"
      />
      
      <StatCard
        bg={statCardBg}
        label="Revenue Per Share"
        value={`$${data.keyStats.revenuePerShare.toFixed(2)}`}
        helpText="Annual revenue divided by shares outstanding"
      />
      
      <StatCard
        bg={statCardBg}
        label="Revenue Per Employee"
        value={formatCurrency(data.keyStats.revenuePerEmployee)}
        helpText="Annual revenue divided by number of employees"
      />
      
      <StatCard
        bg={statCardBg}
        label="Debt to Equity"
        value={data.keyStats.debtToEquity.toFixed(2)}
        helpText="Total debt divided by shareholders' equity"
      />
      
      <StatCard
        bg={statCardBg}
        label="Profit Margin"
        value={`${(data.keyStats.profitMargin * 100).toFixed(2)}%`}
        helpText="Net income as a percentage of revenue"
      />
      
      <StatCard
        bg={statCardBg}
        label="Enterprise Value"
        value={formatCurrency(data.keyStats.enterpriseValue)}
        helpText="Total company value (market cap + debt - cash)"
      />
      
      <StatCard
        bg={statCardBg}
        label="EV to Revenue"
        value={data.keyStats.enterpriseValueToRevenue.toFixed(2)}
        helpText="Enterprise value divided by annual revenue"
      />
      
      <StatCard
        bg={statCardBg}
        label="Price to Book"
        value={data.keyStats.priceToBook.toFixed(2)}
        helpText="Stock price divided by book value per share"
      />
      
      <StatCard
        bg={statCardBg}
        label="PEG Ratio"
        value={data.keyStats.pegRatio.toFixed(2)}
        helpText="P/E ratio divided by earnings growth rate"
      />
    </Grid>
  </>
)

export default KeyStatsPanel
